import { useQuery } from '@tanstack/react-query'
import { Aviso, Cartao } from '@via-tax/ui'
import { mesCurto, reais } from '../formatos'
import { mensagemDeErro, useTRPC } from '../trpc'

/**
 * ICMS lido dos XML das competências do ano-base (as mesmas da simulação: meses fechados do ano corrente).
 * Não depende de simulação: aparece assim que as notas estão na base.
 */
export function IcmsDasNotas({ titulo = 'ICMS lido dos XML (ano-base da simulação)' }: { titulo?: string }) {
  const trpc = useTRPC()
  const q = useQuery(trpc.documento.resumoIcms.queryOptions())
  if (q.isPending) return null
  if (q.isError) return <Aviso>{mensagemDeErro(q.error)}</Aviso>
  const r = q.data
  if (!r.entradas.notas && !r.saidas.notas) return null
  const itens: Array<{ rotulo: string; valor: number; nota: string; destaque?: boolean }> = [
    { rotulo: 'ICMS destacado nas compras', valor: r.entradas.icmsDestacado, nota: `${r.entradas.notas.toLocaleString('pt-BR')} nota(s) de entrada · ${reais(r.entradas.valor)}` },
    { rotulo: 'Dá crédito fora do Simples', valor: r.entradas.icmsCredito + r.entradas.creditoSimples, nota: 'destacado sem ST + crédito de fornecedor do Simples', destaque: true },
    { rotulo: 'Crédito de fornecedor do Simples', valor: r.entradas.creditoSimples, nota: 'vCredICMSSN destacado nas notas' },
    { rotulo: 'ICMS destacado nas vendas', valor: r.saidas.icmsDestacado, nota: `${r.saidas.notas.toLocaleString('pt-BR')} nota(s) de saída · ${reais(r.saidas.valor)}` },
    { rotulo: 'Vendas com ICMS já retido por ST', valor: r.saidas.valorComSt, nota: 'CST 60 / CSOSN 500 · no Simples, o ICMS sai do DAS' },
  ]
  return (
    <Cartao titulo={titulo}>
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-5">
        {itens.map((x) => (
          <div key={x.rotulo} className={`rounded-md border p-3 ${x.destaque ? 'border-navy/40 bg-navy/[0.03]' : 'border-linha'}`}>
            <p className="text-[11px] text-tinta-3">{x.rotulo}</p>
            <p className="num mt-0.5 text-base font-semibold">{reais(x.valor)}</p>
            <p className="text-[11px] text-tinta-3">{x.nota}</p>
          </div>
        ))}
      </div>
      {r.de && r.ate && (
        <p className="mt-2 text-[11px] text-tinta-3">
          Competências de {mesCurto(r.de)} a {mesCurto(r.ate)}, notas autorizadas. ICMS de item com substituição tributária (CST 10/30/70, CSOSN 201–203) não é crédito de quem revende.
        </p>
      )}
    </Cartao>
  )
}
